import { render, staticRenderFns } from "./PopularListOnPlate.vue?vue&type=template&id=05c878a1&scoped=true"
import script from "./PopularListOnPlate.vue?vue&type=script&lang=js"
export * from "./PopularListOnPlate.vue?vue&type=script&lang=js"
import style0 from "./PopularListOnPlate.vue?vue&type=style&index=0&id=05c878a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c878a1",
  null
  
)

export default component.exports